// timestamp must have format '00:00:00,000'
export const convertTimestampStrToMs = (timestamp: string) => {
  const [hours, minutes, seconds, ms] = timestamp.split(/[,:]/).map(Number);
  return hours * 60 * 60 * 1000 + minutes * 60 * 1000 + seconds * 1000 + ms;
};
